import { atom } from 'jotai';

export const notificationsOpenAtom = atom(false);
